<template>
  <div class="buyrecord">
    <div class="czjl">购买记录</div>
    <!-- 没记录的时候 -->
    <div class="wjl-box column aCenter" v-if="buylist.length == 0">
      <img src="../../assets/img/bg_jilu.png" alt="" />
      <div class="zwjl">暂无记录</div>
    </div>
    <div v-else>
      <div class="list-title flex jBetween">
        <div>购买时间</div>
        <div>购买项目</div>
        <div>购买单号</div>
        <div>购买金额</div>
      </div>
      <div
        class="list-con flex jBetween"
        v-for="(item, index) in buylist"
        :key="index"
      >
        <div>{{ item.create_time }}</div>
        <div>{{ item.goods_name }}</div>
        <div>{{ item.order_no }}</div>
        <div>{{ item.price }}元</div>
      </div>
    </div>
  </div>
</template>

<script>
import { buyListApi } from "../../network/api";
import Index from "./Index";
export default {
  name: "Buyrecord",
  mixins: [Index],
  created() {
    let formdata = {
      page: 1,
      limit: 1000,
      token: this.$store.state.userinfo.token,
    };
    buyListApi(formdata)
      .then((res) => {
        console.log(res);
        this.buylist = res.data.data.list;
      })
      .catch();
  },
};
</script>
<style  scoped src="./Buyrecord.css">
</style>